import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords , canonical }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="KRUSHNA PATIL" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="robots" content="index, follow" />
      <link rel='canonical' href={canonical}/>
    </Helmet>
  );
};

export default SEO;
